/**
 * Dependencies.
 */
import { ServicePointOrderModel } from '@/api/service-point/order/order.model';
import applicationConstant from '@/modules/main/constants/application.constant';
import { BaseService } from '@/modules/main/services/base.service';

import { ServicePointOrderPackageModel } from './order-package.model';

/**
 * Service.
 */
class ServicePointOrderPackageService extends BaseService<
ServicePointOrderPackageModel
> {
  /**
   * Constructor.
   */
  constructor() {
    super(
      ServicePointOrderPackageModel,
      ServicePointOrderPackageModel.name,
      applicationConstant.apiServicePointPrivateUrl
    );
  }

  /**
   * Receive package.
   */
  receive(packageCode: string): Promise<ServicePointOrderModel> {
    return this.POST(`${this.getModelEndpoint}/${packageCode}/receive`, {});
  }
}

/**
 * Export `servicePointOrderPackageService`.
 */
export const servicePointOrderPackageService = new ServicePointOrderPackageService();
